import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";
import {HEARD_FASTING} from "../../../../const/FastingQuestionnaire";

export const HeardFasting = (props) => {
    const list = {
        title: "Have you heard about intermittent fasting?",
        list: HEARD_FASTING
    };

    return (
        <div className="gallery-page fasting-heard-page">
            <QuestionnaireSelect list={list} {...props} />
        </div>
    );
};
